import { GetListRes } from "./GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  ChainName = "chainName",
  Currency = "currency",
  SmartAccountType = "smartAccountType",
  WalletMajorVersion = "walletMajorVersion",
  WalletsCount = "walletsCount",
  TotalBalance = "totalBalance",
  Threshold = "threshold",
  SpenderAddress = "spenderAddress",
}

export type TableRow = { [k in TableColumnKey]?: string | null } & {
  id: number;
  isAmountLargerThanThreshold: boolean;
  isWalletCountLargerThanThreshold: boolean;
  thresholdTotalAmount: number;
  isSmartAccount: boolean;
  rawData: GetListRes;
};
